export default __webpack_public_path__ + "static/media/c360v.1a26ffb0.htm";